<template>
<section>
  <PageTitle title="All Billings" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/billings',title:'billings'}]" />
  <div class="wrapper wrapper-content">
    <div class="row">
      <div class="col-lg-7">
        <div class="ibox-title">
          <h5>Commission on Orders</h5>
        </div>
        <div class="ibox-content c2d_cont_1">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Restaurant</label>
                <multiselect v-model="selectedRestaurant" :options="restaurants" :allow-empty="false" placeholder="Select Restaurant" label="name" track-by="name"></multiselect>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Order Source</label>
                <multiselect
                    select-Label=""
                    selected-Label=""
                    deselect-Label=""
                    v-model="orderSource"
                    :options="orderSources"
                    :multiple="true"
                    track-by="source"
                    label="source"
                ></multiselect>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Start Month</label>
                <input id="date_range" type="text" readonly="readonly" placeholder="Search By Date" class="form-control date_picker"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3" v-if="orderSource.length > 0 && orderSource.find( source => source.id === 7)">
              <div class="form-group">
                <label>Foodpanda Order Id</label>
                <input id="foodpandaOrderId" v-model="orderId" type="text" placeholder="Foodpanda order Id" class="form-control date_picker"/>
              </div>
            </div>
            <div :class="orderSource.length > 0 && orderSource.find( source => source.id === 7) ? 'col-md-2' : 'col-md-3'">
              <div class="form-group">
                <label>Total Sale</label>
                <input readonly :value="this.totalAmount.toFixed(2)" type="text" class="form-control">
              </div>
            </div>
            <div :class="orderSource.length > 0 && orderSource.find( source => source.id === 7) ? 'col-md-2' : 'col-md-3'">
              <div class="form-group">
                <label>Subtotal</label>
                <input readonly :value="this.subTotal.toFixed(2)" type="text" class="form-control">
              </div>
            </div>
            <div :class="orderSource.length > 0 && orderSource.find( source => source.id === 7) ? 'col-md-3' : 'col-md-4'">
              <div class="form-group">
                <label>Total Commission Earned <b class="text-danger">{{this.error}}</b></label>
                <input readonly :value="this.commission.toFixed(2)+' '+this.profitConfig" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-2">
              <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-info btn-sm" @click="drawDataTable()"><i class="fa fa-search"></i> Calculate</button>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <div v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                <div class="sk-bounce1"></div>
                <div class="sk-bounce2"></div>
                <div class="sk-bounce3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        <div class="ibox-title center-item">
          <h5 class="pull-left">Commission Earned Details</h5>
          <vue-json-to-csv
              v-if="orderBillingDetails.length > 0"
              :csv-title=fetchFilename()
              class="btn btn-primary pull-right"
              :json-data=orderBillingDetails
              :disabled="!showDownloadBtn"
          > Download CSV
          </vue-json-to-csv>
        </div>
        <div class="ibox-content c2d_cont_1">
          <table class="table table-striped table-responsive table-bordered" id="commissionDetails" >
            <thead>
            <tr>
              <th>Commission Per Order Charges</th>
              <th>Orders Total Price Range (Rs.)</th>
              <th>No of Orders</th>
              <th>Total Commission (Rs.)</th>
              <th>Total Price (Rs.)</th>
            </tr>
            </thead>
            <tbody>
            <tr style="white-space: nowrap" v-for="(resCommission, index) in restaurantCommissionDetails" v-bind:key="index+'_resCommission'">
              <td>{{resCommission.profit}}</td>
              <td>{{resCommission.profitConfig}}</td>
              <td>{{resCommission.noOfOrders}}</td>
              <td>{{parseFloat(resCommission.totalCommission).toFixed(2)}}</td>
              <td>{{resCommission.totalPrice}}</td>
            </tr>
            <tr>
              <td colspan="5" v-if="restaurantCommissionDetails.length === 0" style="text-align: left">No Profit Configuration.</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <br/>
    <div class="row" :class="getTableClass">
      <div class="ibox-content">
        <div class="table-responsive">
          <table class="table table-striped table-bordered table-hover" id="dtTable">
            <thead>
            <tr>
            <th>Order ID</th>
            <th>Branch Name</th>
            <th>Customer Name</th>
            <th>Customer address</th>
            <th>Customer Area</th>
            <th>City</th>
            <th>Subtotal</th>
            <th>Delivery fee</th>
            <th>Total amount</th>
            <th>Tax amount</th>
            <th>Discount</th>
            <th>Billed price</th>
            <th>Commission</th>
            <th>Placed on</th>
            <th>Placing time</th>
            <th>Last updated</th>
            <th>Updated time</th>
            <th>Order type</th>
            <th>Order source</th>
            <th>Taken by</th>
            <th>Status</th>
            <th>Cancellation reason</th>
            <th>Cancellation reason note</th>
            <th>Order wide instructions</th>
            <th>Payment method</th>
            <th>Payment status</th>
            <th>Km distance covered by rider</th>
            <th>Assigned rider name</th>
            <th>assigned rider number</th>
            <th class="text-center"><i class="fa fa-bolt"></i></th>
          </tr>
          </thead>
            <tbody>

            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <ViewOrder showActions="true" ref="viewOrderComp"/>
</section>
</template>

<script>
import {defineComponent} from 'vue'
import Multiselect from "vue-multiselect";
import PageTitle from "@/components/layout_components/PageTitle.vue";
import moment from "moment/moment";
import User from "@/services/User";
import ViewOrder from "@/components/orders/ViewOrder.vue";
import {getCommissionEarned, getBillingStats, downloadBillingDetails} from "@/api/adminBilling";
import VueJsonToCsv from 'vue-json-to-csv'


export default{
  name: "AdminBillings",
  components: {ViewOrder, PageTitle, Multiselect, VueJsonToCsv},
  data() {
    return {
      restaurants:[],
      selectedRestaurant: "",
      orderSources:[],
      orderSource:[],
      orderBillingDetails:[],
      subTotal: 0,
      totalAmount: 0,
      commission: 0,
      totalDelivery: 0,
      profitConfig: "",
      dateRange: null,
      isHideSpinner: "hide",
      ordersFetched: false,
      restaurantCommissionDetails: [],
      error: "",
      dataTable: null,
      showDataTable: false,
      showDownloadBtn: false,
      columnNumbers: Array.from(Array(29), (_, index) => index),
      orderId: "",
    }
  },

  computed: {
    userRole() {
      return this.$store.getters.user.userRolesById[0].role;
    },
    getTableClass() {
      return this.orderBillingDetails.length === 0 ? 'hide-table' : 'show-table';
    }
  },

  watch: {
    orderSource: {
      handler (val) {
        if (this.orderId !== "" && !val.some(e=>e.id === 7)) {
          this.orderId = ""
        }
      }
    }
  },

  mounted() {
    $('.date_picker').daterangepicker({
      format: 'YYYY-MM-DD',
      maxDate: new Date,
      minDate: moment().subtract(3,'M')
    }).on('apply.daterangepicker', function(ev, picker) {
      $(this).val(picker.startDate.format('YYYY-MM-DD') + ' <==> ' + picker.endDate.format('YYYY-MM-DD'));
    }).on('cancel.daterangepicker', function(ev, picker) {
      $(this).val('');
    });
  },

  created() {
    User.fetchUserRoles().then(role => {
      this.loggedInRole = role;
      if(role === 'ROLE_ADMIN' || role === 'ROLE_AGENT'){
        this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
          this.restaurants = resp.data;
        });
      }else if(role === 'ROLE_USER'){
        this.selectedRestaurant = this.$store.state.user.restaurant;
        this.defaultRestaurant = this.$store.state.user.restaurant;
        this.restaurants.push({id: this.$store.state.user.restaurant.id, name: this.$store.state.user.restaurant.name});
      }
    });

    this.$http.get(this.$store.state.mainAppURL + "orders/get_all_order_source").then(resp=>{
      this.orderSources= resp.data;
    });
  },

  methods: {
    intializeTable(processingURL) {
      this.$nextTick(function() {
        let self = this;
        self.dataTable = $('#dtTable').DataTable({
          "processing": true,
          "serverSide": true,
          "scrollX": true,
          "ordering": false,
          "dom": 'ltipr',
          "order": [[0, "desc"]],
          "lengthMenu": [10, 25, 50, 75, 100, 250],
          "columnDefs": [
            {
              "width": "4%",
              "targets": self.columnNumbers
            },
            {
              'headerClassName': "text-center",
              'targets': self.columnNumbers
            }
          ],
          'language': {
            //'loadingRecords': 'Please wait - loading...',
            'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                '                <div class="sk-double-bounce1"></div>\n' +
                '                <div class="sk-double-bounce2"></div>\n' +
                '              </div>'
          },
          ajax: {
            url: processingURL,
            type: 'GET',
            data: function (d) {
              delete d.columns
            },
            headers: {
              "Content-type": "application/json; charset=utf-8"
            },
            beforeSend: (xhr) => {
              xhr.setRequestHeader('Authorization', 'Bearer ' + self.$store.state.accessToken);
            },
            statusCode: {
              401: () => {
                self.updateRefreshTokenInDataTable(self.dataTable);
              }
            }
          },
          "columns": [
            {"data": "orderId", "name": "id"},
            {
              "data": "branchName",
              "name": "branchName",
              "render": function (data) {
                if (data === null) {
                  return "N/A";
                } else {
                  return data;
                }
              }
            },
            {
              "data": "customerName",
              "name": "customer_name",
              "render": function (data, type, row) {
                if (row.baykedCustomerName !== null) {
                  return row.baykedCustomerName;
                } else if (row.customerName !== null) {
                  return row.customerName;
                } else {
                  return "N/A";
                }
              }
            },
            {
              "data": "address",
              "name": "address",
              "render": function (data) {
                return (data !== null && data !== "Dummy") ? data : "N/A"
              }
            },
            {
              "data": "areaName",
              "name":"customer_area",
              "render": function(data, type, row){
                if(row.orderTypesId !== 3){
                  return "N/A";
                }return data;
              }
            },
            {
              "data": "cityName",
              "name":"customer_city",
              "render": function(data, type, row){
                if(row.orderTypesId !== 3){
                  return "N/A";
                }return data;
              }
            },
            {
              "data": "subTotal", "name": "subTotal",
            },
            {"data": "deliveryFee", "name": "deliveryFee"},
            {
              "data": "totalAmount",
              "name": "totalAmount",
              "render": function (data, type, row) {
                return row.totalAmount !== null ?  row.totalAmount + row.deliveryFee : row.deliveryFee;
              }
            },
            {
              "data": "cardTax",
              "name": "cardTax",
              "render": function (data, type, row) {
                if (row.paymentMethodId === 1 || row.paymentMethodId === 3) {
                  return ((row.tax / 100) * row.totalAmount).toFixed(2)
                } else {
                  return ((row.cardTax /100) * row.totalAmount).toFixed(2)
                }
              }
            },
            {"data": "discount", "name": "discount"},
            {"data": "billedPrice","name":"billedPrice"},
            {
              "data": "commission",
              "name": "commission",
              "render": function (data, type, row) {
                  return (row.commission !== null && row.orderStatus !== 9 && row.commission !== 0) ? row.commission.toFixed(2) : 0;
              }
            },
            {
              "data": "orderCreated",
              "name": "orderCreated",
              "render": function (data, type, row) {
                return "<span class='m_tip label label-default'>"+self.dateFormat(row.orderCreated)+"</span>";
              }
            },
            {
              "data": "orderCreatedTime",
              "name": "orderCreatedTime",
              "render": function (data, type, row) {
                return "<span class='m_tip label label-default'>"+self.timeFormat(row.orderCreated)+"</span>";
              }
            },
            {
              "data": "orderModified",
              "name": "orderModified",
              "render": function (data, type, row) {
                return "<span class='m_tip label label-default'>"+self.dateFormat(row.orderModified)+"</span>";
              }
            },
            {
              "data": "orderModifiedTime",
              "name": "orderModifiedTime",
              "render": function (data, type, row) {
                return "<span class='m_tip label label-default'>"+self.timeFormat(row.orderModified)+"</span>";
              }
            },
            {
              "data": "orderTypeName",
              "name":"orderType"
            },
            {
              "data": "orderSourceName",
              "name":"orderSourceName"
            },
            {
              "data": "agentName",
              "name":"TakenBy",
              "render": function(data, type, row){
                if(data===null){
                  return "Baked App Order"
                }else{
                  return data;
                }
              }
            },
            {
              "data": "statusName",
              "name": "statusName",
              "render": data => data ?data : 'N/A'
            },
            {
              "data": "cancellationReason",
              "name": "cancellationReason",
              "render": data => data ?data : 'N/A'
            },
            {
              "data": "otherCancellationReasons",
              "name": "otherCancellationReasons",
              "render": data => data ?data : 'N/A'
            },
            {"data": "orderWideInstructions", "name": "orderWideInstructions", "render": data => data ?data : 'N/A'},
            {"data": "paymentMethodName", "name": "paymentMethodName"},
            {"data": "paymentStatusName", "name": "paymentStatusName"},
            {"data": "totalDistance", "name": "totalDistance"},
            {"data": "riderName", "name": "riderName", "render": data => data ?data : 'N/A'},
            {"data": "riderContactNumber", "name": "riderContactNumber", "render": data => data ?data : 'N/A'},
            {
              "data": "actions",
              "render": function(data, type, row){
                return '<a data-id="'+row.orderId+'" class="btn btn-xs btn-primary view_btn" href="javascript:void(0)">View</a>';
              },
              "name":"actions"
            },
          ],
          "drawCallback": function( settings ) {
            $(".m_tip").tooltip();
            $(".view_btn").click( function() {
              let orderId = $(this).attr("data-id");
              self.fetchOrderDetail(orderId);
            });
          }
        });
      });
    },

    createQueryParams(dateRange) {
      let start = dateRange[0];
      let end = dateRange[1];
      let params = new URLSearchParams();
      params.append("from", start);
      params.append("end", end);
      params.append("restaurant_id", this.selectedRestaurant.id);
      params.append("foodpanda_order_id", this.orderId)
      for (let os of this.orderSource) {
        params.append("order_source", os.id);
      }
      return params;
    },

    async drawDataTable() {
      if (!this.selectedRestaurant) {
        swal("Error!", "Kindly Select Restaurant", "error");
        return;
      }
      let dateRange = $("#date_range").val().split(" <==> ")
      if (dateRange[0] === '') {
        swal("Error!", "Kindly Select Date Range", "error");
        return;
      }
      if (this.dataTable) {
        this.dataTable.destroy();
      }
      let params = this.createQueryParams(dateRange);
      let processingURL = this.$store.state.mainAppURL + `admin_billing?${params}`

      await this.intializeTable(processingURL)
      this.showDataTable = true;
      this.getCommission(dateRange)
      this.getBillingStatsDetails(params)
      this.downloadCsv()
      this.showDownloadBtn = true;
    },

    async getBillingStatsDetails(params) {
      try {
        const resp = await getBillingStats(params)
        let billing = resp.data.body
        this.subTotal = Number(billing.subTotal)
        this.totalAmount = Number(billing.totalAmount)
        this.commission = Number(billing.totalCommission)
      } catch (e) {
        this.showErrorMessage(e)
      }
    },

    async getCommission(dateRange) {
      let start = dateRange[0];
      let end = dateRange[1];
      let params = new URLSearchParams();
      params.append("start", start + " 00:00:00.0");
      params.append("end", end + " 23:59:59.0");
      params.append("restaurant_id", this.selectedRestaurant.id);
      const commissionEarnedDetails = await getCommissionEarned(params)
      this.restaurantCommissionDetails = commissionEarnedDetails.data && commissionEarnedDetails.data.body
    },

    getValidString: function(stringValue){
      if(stringValue !== null && stringValue !== ""){
        return stringValue;
      }
      return "N/A";
    },

    dateFormat (date) {
      return this.$moment.parseZone(date).local().format('DD/MM/YYYY');
    },

    timeFormat (date){
      return this.$moment.parseZone(date).local().format('hh:mm:ss A');
    },

    fetchOrderDetail: function (orderId) {
      this.$refs.viewOrderComp.fetchOrderDetail(orderId);
    },

    async downloadCsv () {
      try {
        let dateRange = $("#date_range").val().split(" <==> ")
        if (dateRange[0] === '') {
          swal("Error!", "Kindly Select Date Range", "error");
          return;
        }
        let params = this.createQueryParams(dateRange);
        const resp = await downloadBillingDetails(params)
        if (resp.data.body.length > 0) {
          this.orderBillingDetails = resp.data.body
        } else {
          this.orderBillingDetails = []
        }
        this.dateRange = `(${dateRange[0]} to ${dateRange[1]})`
      } catch (e) {
        this.showErrorMessage(e)
      }
    },

    fetchFilename() {
      let fileName = 'Sales Reports';
      if (this.selectedRestaurant && this.selectedRestaurant.name) {
        fileName = `${this.selectedRestaurant.name} Sales Reports`;
        fileName += this.dateRange ? ` ${this.dateRange}` : '';
      }
      return fileName;
    }

  }
}
</script>

<style scoped>
.wrap_class{
  white-space: nowrap;
}

.center-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hide-table {
  display: none;
}

.show-table {
  display: block;
}

.c2d_cont_1{
  height: 220px !important;
  overflow: auto;
}

th, #commissionDetails{
  text-align: center;
}


</style>